module.exports = __webpack_public_path__ + "img/western-province-logo-icon.8920bb70.png";